<template>
  <div class="page-top editor-pick editor-pick-header">
    <div :class="['page-top-inner-wrap', 'page']">
      <h1 tabindex="0" class="page-title" v-html="title"></h1>
      <p
        v-for="(subTitle, index) in subTitles"
        :key="`${subTitle}__${index}`"
        v-html="subTitle"
      ></p>
      <div class="btn-wrap">
        <BtnZzimWithEvent
          v-if="!isWavveOn"
          :is-on="isZzim"
          :event-list="eventList"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, computed } from 'vue'
  import cookie from '@/common/utils/cookie'
  import BtnZzimWithEvent from '@/components/button/BtnZzimWithEvent.vue'
  import { convertEventBodyJson } from '@/common/utils/like-status/convert-event-body-json'

  const props = defineProps({
    titleList: {
      type: Array,
      default: null,
    },
    topButtonList: {
      type: Array,
      default: null,
    },
  })

  const isZzim = ref('n')
  const title = ref('') // string
  const subTitles = ref([]) // string[]
  const eventList = ref({})

  const isWavveOn = computed(() => cookie.isWavveOn())
  const likeStatus = computed(() => props.topButtonList?.[0])

  // 찜 여부 세팅
  const setLikeStatus = () => {
    isZzim.value = likeStatus.value?.butonstate ?? 'n'
    eventList.value = convertEventBodyJson(likeStatus.value?.event_list)
  }

  // 타이틀 인터렉션 세팅
  const setTitle = () => {
    const [_title, ..._subTitles] = props.titleList.map((title) => title?.text)

    title.value = _title
    subTitles.value = _subTitles
  }

  const init = () => {
    setTitle()
    setLikeStatus()
  }

  init()
</script>
